import { makeObservable } from 'mobx';
import NumeroProcessoUtil from '../../util/NumeroProcessoUtil';
import { Filtro } from './Filtro';

export default class FiltroClasseJudicialCompleta extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Classe judicial completa (fase composta)';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return NumeroProcessoUtil.getClasseProcessual(registro.processo.numeroCompleto);
    }
}
